import React, { useMemo } from 'react'
import Seo from '../Seo'

const env = (typeof process !== 'undefined' && process.env) || {}

const DEFAULTS = {
  embedUrl: 'https://app.leanit101.com/benjamin',
  embedToken:
    'eyJvcmdhbml6YXRpb25JZCI6NDIsImFnZW50U2x1ZyI6Im1vbnRjbGFzcy1zYWxlcy1hc3Npc3RhbnQiLCJ0ZW5hbnRTbHVnIjoibW9udGNsYXNzIiwiYXNzaXN0YW50TmFtZSI6Ik1hdGhldXMiLCJncmVldGluZ3MiOnsiZW4iOiJIZWxsbywgSSdtIE1hdGhldXMgZnJvbSBNb250Y2xhc3MuIFBsZWFzZSB0ZWxsIG1lIGJyaWVmbHkgd2hhdCBjYXVnaHQgeW91ciBpbnRlcmVzdCBzbyBJIGNhbiBndWlkZSB5b3UuIiwiZXMiOiJIb2xhLCBzb3kgTWF0aGV1cywgZGUgTW9udGNsYXNzLiBDdcOpbnRhbWUsIHBvciBmYXZvciwgZW4gcG9jYXMgcGFsYWJyYXMgcXXDqSBkZXNwZXJ0w7MgdHUgaW50ZXLDqXMgeSB0ZSBvcmllbnRhcsOpLiIsInB0IjoiT2zDoSwgc291IE1hdGhldXMsIGRhIE1vbnRjbGFzcy4gRmlxdWUgw6Agdm9udGFkZSBwYXJhIG1lIGNvbnRhciwgZW0gcG91Y2FzIHBhbGF2cmFzLCBvIHF1ZSBkZXNwZXJ0b3Ugc2V1IGludGVyZXNzZSBwYXJhIHF1ZSBldSB0ZSBvcmllbnRlLiJ9LCJtZXRhZGF0YSI6eyJjaGFubmVsRGVmYXVsdCI6IndlYl9lbWJlZCIsImRlZmF1bHRMb2NhbGUiOiJwdC1CUiJ9fQ.93413dd5450f9f938694427558ed80ef001fd315fd778789b386fc97b93d43ef',
  agentSlug: 'montclass-sales-assistant',
  tenantSlug: 'montclass',
  organizationId: '42',
  assistantName: 'Matheus',
  channel: 'web_embed',
  utmSource: 'leanit101.com',
  utmCampaign: 'montclass-sales-poc',
}

const MontclassSalesPage = () => {
  const queryParams = useMemo(() => {
    if (typeof window === 'undefined') return new URLSearchParams('')
    return new URLSearchParams(window.location.search || '')
  }, [])

  const embedToken =
    queryParams.get('token') ||
    env.REACT_APP_MONTCLASS_EMBED_TOKEN ||
    DEFAULTS.embedToken

  const agentSlug =
    queryParams.get('agentSlug') ||
    env.REACT_APP_MONTCLASS_AGENT_SLUG ||
    DEFAULTS.agentSlug

  const tenantSlug = (
    queryParams.get('tenantSlug') ||
    env.REACT_APP_MONTCLASS_TENANT_SLUG ||
    DEFAULTS.tenantSlug
  )
    .toString()
    .trim()
    .toLowerCase()

  const organizationId =
    queryParams.get('organizationId') ||
    env.REACT_APP_MONTCLASS_ORGANIZATION_ID ||
    DEFAULTS.organizationId

  const assistantName =
    queryParams.get('assistantName') ||
    env.REACT_APP_MONTCLASS_ASSISTANT_NAME ||
    DEFAULTS.assistantName

  const channel = queryParams.get('channel') || DEFAULTS.channel
  const utmSource = queryParams.get('utm_source') || DEFAULTS.utmSource
  const utmCampaign = queryParams.get('utm_campaign') || DEFAULTS.utmCampaign

  const iframeSrc = useMemo(() => {
    const params = new URLSearchParams()
    if (embedToken) params.set('token', embedToken)
    params.set('agentSlug', agentSlug)
    params.set('tenantSlug', tenantSlug)
    params.set('organizationId', organizationId)
    params.set('assistantName', assistantName)
    params.set('channel', channel)
    params.set('locale', 'pt-BR')
    if (utmSource) params.set('utm_source', utmSource)
    if (utmCampaign) params.set('utm_campaign', utmCampaign)
    params.set('meta.source', 'montclass-sales-poc')
    params.set('meta.partner', 'montclass')

    const baseUrl = env.REACT_APP_MONTCLASS_EMBED_URL || DEFAULTS.embedUrl
    return `${baseUrl}?${params.toString()}`
  }, [
    agentSlug,
    assistantName,
    channel,
    embedToken,
    organizationId,
    tenantSlug,
    utmCampaign,
    utmSource,
  ])

  return (
    <section className="relative flex min-h-screen w-full flex-col overflow-hidden bg-[#06070d] text-white">
      <Seo
        title="Montclass | Concierge Comercial"
        description="POC privada para validação do concierge comercial da Montclass."
        path="/montclass-sales"
        noindex
      />

      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#12131b] via-[#06070d] to-[#06070d]" />
        <div
          className="absolute left-[8%] top-[-160px] h-[640px] w-[640px] rounded-full opacity-30"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(214,180,108,0.34) 0%, rgba(214,180,108,0) 68%)',
            filter: 'blur(58px)',
          }}
        />
        <div
          className="absolute bottom-[-240px] right-[-120px] h-[580px] w-[580px] rounded-full opacity-18"
          style={{
            background:
              'radial-gradient(50% 50% at 50% 50%, rgba(122,139,171,0.22) 0%, rgba(122,139,171,0) 64%)',
            filter: 'blur(48px)',
          }}
        />
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage:
              'linear-gradient(to right, rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.06) 1px, transparent 1px)',
            backgroundSize: '32px 32px',
          }}
        />
      </div>

      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 py-12 md:py-16">
        <header className="space-y-4 text-center">
          <p className="text-xs uppercase tracking-[0.42em] text-[#d6b46c]/80">
            Montclass
          </p>
          <h1 className="text-3xl font-semibold md:text-5xl">
            Matheus • concierge comercial premium
          </h1>
          <p className="mx-auto max-w-3xl text-base text-slate-200 md:text-lg">
            Página de POC para validar a recepção comercial da Montclass com um
            tom mais sofisticado, humano e discreto. O foco aqui é orientar bem
            o lead, responder com elegância e conduzir oportunidades sérias para
            uma conversa com o time.
          </p>
        </header>

        <div className="grid gap-6 lg:grid-cols-[1.1fr_minmax(320px,0.9fr)]">
          <div className="w-full overflow-hidden rounded-[28px] border border-[#d6b46c]/14 bg-[#0d1018]/75 shadow-2xl">
            <div className="border-b border-white/8 px-5 py-4">
              <div className="text-[11px] uppercase tracking-[0.34em] text-[#d6b46c]/70">
                Conversa ao vivo
              </div>
              <div className="mt-2 text-sm text-slate-300">
                Fluxo em português voltado para recepção comercial, contexto do
                interesse, percepção de fit e avanço para reunião quando a
                conversa justificar um próximo passo mais dedicado.
              </div>
            </div>
            <div className="relative h-[560px] w-full md:h-[660px]">
              <iframe
                title="Montclass — concierge comercial"
                src={iframeSrc}
                allow="clipboard-read; clipboard-write"
                className="absolute inset-0 h-full w-full"
                style={{ background: 'transparent', border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          <div className="grid content-start gap-4">
            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#d6b46c]/76">
                Posicionamento
              </div>
              <h2 className="mt-3 text-xl font-semibold">
                Sofisticação, confiança e discrição comercial
              </h2>
              <p className="mt-3 text-sm leading-6 text-slate-200">
                O Matheus foi configurado para representar a Montclass como uma
                marca premium, confiável e seletiva, sem soar como SDR
                genérico, sem empurrar reunião cedo demais e sem transformar a
                conversa em brochura.
              </p>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#d6b46c]/76">
                O que observar
              </div>
              <ul className="mt-3 space-y-3 text-sm leading-6 text-slate-200">
                <li>Se o tom parece humano, elegante e seguro, sem parecer robótico.</li>
                <li>Se o agente entende o contexto antes de empurrar qualificação ou agenda.</li>
                <li>Se as respostas são breves, úteis e compatíveis com uma marca premium.</li>
                <li>Se o avanço para reunião acontece com naturalidade, não como funil mecânico.</li>
              </ul>
            </div>

            <div className="rounded-2xl border border-[#d6b46c]/18 bg-[#11141d] p-5">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#d6b46c]/82">
                Compartilhamento
              </div>
              <p className="mt-3 text-sm leading-6 text-slate-200">
                Use este link com o cliente para validação da POC:
              </p>
              <code className="mt-3 block break-all text-xs text-amber-200 md:text-sm">
                https://leanit101.com/montclass-sales
              </code>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur-sm">
              <div className="text-[11px] uppercase tracking-[0.3em] text-[#d6b46c]/76">
                Contexto da POC
              </div>
              <p className="mt-3 text-sm leading-6 text-slate-200">
                Esta página envia o embed com <strong>organizationId 42</strong>,
                locale <strong>pt-BR</strong> e metadados específicos da POC da
                Montclass, voltada para recepção comercial de oportunidades em
                real estate premium na Costa Esmeralda.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MontclassSalesPage
